import { createCrudHooks } from './use-crud-factory'
import type { SupabaseQueryChain } from '@/types/supabase-helpers'
import type { Event } from '@/types/database.types'

/* ============================================================
   useEvents — PRD §8.6
   CRUD for event records.
   ============================================================ */

const {
  useList: useEventList,
  useOne: useEvent,
  useCreate: useCreateEvent,
  useUpdate: useUpdateEvent,
  useDelete: useDeleteEvent,
} = createCrudHooks<Event>({
  table: 'events',
  queryKey: 'events',
  orderBy: 'event_date',
  orderAsc: true,
  defaultFilter: (q: SupabaseQueryChain) => q.eq('is_active', true),
})

export {
  useEventList,
  useEvent,
  useCreateEvent,
  useUpdateEvent,
  useDeleteEvent,
}

export { useEventList as useEvents }
